export default __webpack_public_path__ + "static/media/023-notification.9f486f30.svg";